// extracted by mini-css-extract-plugin
export var header = "_46-0";